<template>
  <confirmation-box
      :id="id"
      :main-msg="msg"
      :ok-msg="okMsg"
      :cancel-msg="cancelMsg"
      @ok="$emit(event);"
  />
</template>

<script>
import ConfirmationBox from "@/components/confirmationBox";

export default {
  name: "lpModal",
  components: {ConfirmationBox},
  props: {
    id: String,
    access: Boolean,
  },
  data() {
    let msg, okMsg, cancelMsg, event
    if (this.access) {
      msg = ['Tu vas envoyer le devoir au prof.',
        'Après tu ne pourras plus le modifier.',
        'Veux-tu vraiment l\'envoyer ?'];
      okMsg = "Oui, je l'envoie";
      cancelMsg = "Non, je le garde";
      event = "submit";
    } else {
      msg = ['Inscris toi :)'];
      okMsg = "Je m'inscris";
      cancelMsg = "Plus Tard";
      event = "register";
    }
    return {
      msg,
      okMsg,
      cancelMsg,
      event
    }
  },
}
</script>

<style scoped>

</style>